import React from "react";
import "./SearchInput.scss";
import AuiIcon from "../AuiDropdown/AuiIcon";

interface SearchInputProps {
  localSearchTerm: string;
  setLocalSearchTerm: (value: string) => void;
  onClear: () => void;
  placeholder?: string;
  label?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  localSearchTerm,
  setLocalSearchTerm,
  onClear,
  placeholder = "Search",
  label = "Search",
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLocalSearchTerm(event.target.value);
  };

  return (
    <div className="search-input-container">
      <label htmlFor="search-input" className="searchLabel">
        {label}
      </label>
      <div className="d-flex align-items-center position-relative">
        <span className="input-group-text">
          <AuiIcon iconClass="search" svgwidth="17" svgheight="17"></AuiIcon>
        </span>
        <input
          id="search-input"
          type="text"
          value={localSearchTerm}
          onChange={handleChange}
          placeholder={placeholder}
          className="search-input"
          autoComplete="off"
        />
      </div>
      {localSearchTerm && (
        <button
          onClick={onClear}
          className="clear-icon"
          aria-label="Clear search input"
        >
          <AuiIcon iconClass="closeIcon" svgwidth="12" svgheight="12"></AuiIcon>
        </button>
      )}
    </div>
  );
};

export default SearchInput;
